import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

import { firebaseApp } from "../utils/auth/initFirebase";

export const functions = getFunctions(firebaseApp);

// TODO: Readd with environment variables for local development
// connectFunctionsEmulator(functions, "localhost", 5001);
